import { z } from 'zod'
import { stringArrayToSelectOptions } from '@/utils/misc.ts'

export const TimePeriod = z.object({
  numberOf: z.number(),
  type: z.string().min(1),
})
export type TimePeriod = z.infer<typeof TimePeriod>

export const Money = z.object({
  currency: z.string().min(1),
  amount: z.number(),
})
export type Money = z.infer<typeof Money>;

export const Percent = z.coerce.number().refine(x => x >= 0 && x <= 1, 'Percent/Rate must be within 0-100')
export type Percent = z.infer<typeof Percent>;

export const NaturalNumber = z.coerce.number().int().min(1)
export type NaturalNumber = z.infer<typeof NaturalNumber>;

// accept 2024-01-01 or 1 January 2024 or 01 January 2024
export const DateString = z.string().regex(
  /(^\d{4}-\d{2}-\d{2}$)|(^(January|February|March|April|May|June|July|August|September|October|November|December) \d{1,2}, \d{4}$)/)
export type DateString = z.infer<typeof DateString>;

export const AddressField = z.object({
  postalCode: z.string().nullable().optional(),
  country: z.string().min(1),
  stateOrProvince: z.string().nullable().optional(),
  city: z.string().min(1),
  street: z.string().min(1),
})
export type AddressField = z.infer<typeof AddressField>;

export const TimeDurationField = z.object({
  years: z.coerce.number().min(0),
  months: z.coerce.number().min(0),
  days: z.coerce.number().min(0),
})
export type TimeDurationField = z.infer<typeof TimeDurationField>;

// eslint-disable-next-line @typescript-eslint/ban-types
export type ExcludeMethods<T> = { [K in keyof T as (T[K] extends Function ? never : K)]: T[K] }

export type ArrayElement<T> = T extends (infer U)[] ? U : never

export enum Gender {
  Male = 'Male',
  Female = 'Female',
}

export enum TerminationMeetingType {
  Meeting = 'Meeting',
  Discussion = 'Discussion',
}

export enum StatutoryType {
  Severance = 'Severance',
  LongService = 'LongService'
}

export enum TerminationType {
  Resignation = 'Resignation',
  Termination = 'Termination',
}

export const EmptyData = {
  string: '(Empty)',
}

export enum TerminationInternType {
  Resignation = 'Resignation',
  Termination = 'Termination',
  Completion = 'Completion'
}

export enum PaymentItems {
  ThreeDays = 'three days',
  SevenDays = 'seven days',
}

export const FxRateHistoryType = {
  MonthlyAverage: 'Monthly Average',
  MonthlyClosing: 'Monthly Closing',
  YtdAverageAverage: 'YTD Average - Monthly Average',
  YtdAverageClosing: 'YTD Average - Monthly Closing',
}
export const FxRateHistoryTypeOptions = stringArrayToSelectOptions(Object.values(FxRateHistoryType))

export const Month = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
export const MonthShort = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']